"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _theme = require("../theme");

var _core = require("@emotion/core");

var StyledSvg = (0, _theme.styled)('svg')(function (_ref) {
  var theme = _ref.theme,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? _theme.constants.SEMANTIC_COLOR_NAME.CORE1_100 : _ref$color;
  return {
    fill: theme.palette[color]
  };
});

function Logo(props) {
  var _props$alignX = props.alignX,
      alignX = _props$alignX === void 0 ? 'left' : _props$alignX,
      color = props.color,
      _props$height = props.height,
      height = _props$height === void 0 ? '100%' : _props$height,
      _props$size = props.size,
      size = _props$size === void 0 ? 'default' : _props$size,
      _props$width = props.width,
      width = _props$width === void 0 ? '100%' : _props$width;
  var theme = (0, _theme.useTheme)();
  var themeName = theme.branding.name;
  var logoSprite = typeof theme.components.logo.url === 'function' ? theme.components.logo.url() : theme.components.logo.url;
  return (0, _core.jsx)(StyledSvg, {
    color: color,
    height: height,
    width: width
  }, (0, _core.jsx)("use", {
    xlinkHref: "".concat(logoSprite, "#").concat(themeName, "-").concat(size, "-").concat(alignX)
  }));
}

var _default = Logo;
exports.default = _default;